import React from "react";
import { selectFormat } from "components/Utils/Utils";

function transformMonthsToLabels(months) {
  return months
    .map((dateStr) => {
      const date = new Date(dateStr);
      const monthName = date.toLocaleString("en-US", { month: "short" });
      const year = date.getFullYear();
      return `${monthName} ${year}`;
    })
    .concat("Averages"); // Append "Averages" at the end
}

function augmentDataWithLabels(data, months) {
  const topRowLabels = ["Month", ""];
  for (let i = 1; i <= 12; i++) {
    topRowLabels.push(i.toString()); // Adding labels 1 to 12
  }

  const yLabels = transformMonthsToLabels(months);

  const newData = [topRowLabels, ...data];

  return newData.map((row, index) => {
    if (index === 0) return row;
    // Replace or insert the yLabel for each data row
    return [yLabels[index - 1] || "", ...row];
  });
}

function getBackgroundColor(value) {
  if (value === 0) return "#f3f3f3"; // Special case for 0

  // Ensure value is within bounds
  value = Math.max(0, Math.min(1, value));

  // Calculate red and green components based on value
  const red = Math.round(255 * (1 - value));
  const green = Math.round(255 * value);

  return `rgb(${red}, ${green}, 0)`;
}
function renderCell(cell, cellIndex, rowIndex, dataLength, maxValue) {
  const isLastRow = rowIndex === dataLength - 1;
  const isFirstRow = rowIndex === 0;
  const isFirstColumn = cellIndex === 0;
  const isSecondColumn = cellIndex === 1;
  const isFirstTwoColumns = cellIndex === 0 || cellIndex === 1;

  let backgroundColor = "transparent";
  if (!isFirstTwoColumns && !isLastRow && !isFirstRow) {
    backgroundColor = getBackgroundColor(cell, maxValue, cellIndex);
  }

  const cellContent = formatCellContent(
    cell,
    cellIndex,
    rowIndex,
    dataLength,
    isLastRow,
    isFirstRow
  );

  let className = `heatmap-grid-item ${isFirstRow ? "heatmap-top-label" : ""} ${
    isLastRow ? "average" : ""
  }`;

  if (isFirstColumn) {
    className += " heatmap-first-column";
  }

  if (isSecondColumn) {
    className += " heatmap-second-column";
  }

  return (
    <div
      key={`${rowIndex}-${cellIndex}`}
      className={className}
      style={{ backgroundColor }}
    >
      {cellContent}
    </div>
  );
}

function formatCellContent(
  cell,
  cellIndex,
  rowIndex,
  dataLength,
  isLastRow,
  isFirstRow
) {
  if (cell === 0 && !isFirstRow) return "";
  if (cellIndex === 0) return cell;
  if (isFirstRow) return cell;

  let formatType, formatPattern;

  if (cellIndex === 1) {
    formatType = "number";
    formatPattern = "0,0";
  } else if (isLastRow && cellIndex > 1) {
    formatType = "percentage";
    formatPattern = "%0.0";
  } else {
    formatType = "percentage";
    formatPattern = "%0.0";
  }

  return selectFormat(formatType, cell, formatPattern);
}

const LeeRetentionBurnDown = (props) => {
  const data = augmentDataWithLabels(props.data.data, props.data.months);

  return (
    <div
      className="heatmap-grid-container"
      style={{ gridTemplateColumns: `repeat(${data[0].length}, 1fr)` }}
    >
      {data.map((row, rowIndex) =>
        row.map((cell, cellIndex) =>
          renderCell(cell, cellIndex, rowIndex, data.length, 10)
        )
      )}
    </div>
  );
};

export default LeeRetentionBurnDown;
